import sortBy from 'lodash/sortBy';

const generateId = (item, level) => {
	let id = '';

	for (let i = 1; i <= level; i++) {
		id = `${id}${item[`project_L${i}Category`]}`;
	}

	return id;
};

const AP_PREFIX = 'AP - ';

const addExtraLevel = (nodes, item) => {
	const propName = 'aP_L4Category';
	const existingNode = nodes.find(node => node.name === item[propName]);

	if (existingNode) {
		return nodes;
	}

	return sortBy(
		[
			...nodes,
			{
				level: 5,
				name: `${AP_PREFIX}${item[propName]}`,
				value: item.project_L4Category,
				id: `${generateId(item, 4)}${item.aP_L4Code}`,
				children: [],
				data: item,
			},
		],
		'name'
	);
};

const addTreeLevel = (nodes, item, level = 1) => {
	const levelName = `project_L${level}Category`;

	if (!item[levelName]) {
		if (item.aP_L4Category) {
			return addExtraLevel(nodes, item);
		}

		return nodes;
	}

	const existingNode = nodes.find(node => node.name === item[levelName]);

	if (existingNode) {
		const children = addTreeLevel(existingNode.children, item, level + 1);

		existingNode.children = children;

		if (children.length === 0) {
			existingNode.data = item;
			existingNode.id = `${generateId(item, level)}${item.aP_L4Code || ''}`;
		}

		return nodes;
	}

	const children = addTreeLevel([], item, level + 1);

	return sortBy(
		[
			...nodes,
			{
				level,
				name: item[levelName],
				value: item[levelName],
				id: `${generateId(item, level)}${(children.length === 0 &&
					item.aP_L4Code) ||
					''}`,
				data: item,
				children,
				...(children.length === 0 ? { data: item } : {}),
			},
		],
		'name'
	);
};

export const getTaxonomyTree = data => {
	if (!data) {
		return [];
	}

	return data.reduce((acc, item) => {
		return addTreeLevel(acc, item);
	}, []);
};

export const getTaxonomyOptions = data => {
	if (!data) {
		return [];
	}

	return sortBy(
		data.map(item => {
			return {
				name: item.project_L4Category,
				value: item.project_L4Category,
				id: `${generateId(item, 4)}${item.aP_L4Code || ''}`,
				data: item,
				...(item.aP_L4Category
					? { info: `${AP_PREFIX}${item.aP_L4Category}` }
					: {}),
			};
		}),
		'name'
	);
};
